var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"value":_vm.group,"clearable":"","label":_vm.$t('role'),"single-line":"","items":_vm.roles},on:{"input":function($event){return _vm.$emit('update-groups', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }